import { Anchor, Flex, Text } from '@mantine/core';
import { NavLink } from 'react-router';

type VacanciesTemplatesBreadcrumbsProps = {
  withListLink?: boolean;
  subPage: string;
};

export const VacanciesTemplatesBreadcrumbs = ({
  withListLink = true,
  subPage,
}: VacanciesTemplatesBreadcrumbsProps) => (
  <Flex gap={4}>
    <Anchor to='/' component={NavLink} variant='gray'>
      Настройки
    </Anchor>
    {withListLink && (
      <>
        <Text>/</Text>
        <Anchor
          to='/vacancies-templates-list'
          component={NavLink}
          variant='gray'
        >
          Шаблоны вакансий
        </Anchor>
      </>
    )}
    <Text>/</Text>
    <Text c='tertiary.4'>{subPage}</Text>
  </Flex>
);
